"use client";

interface HowItWorksSectionProps {
  title?: string | null;
  description?: string | null;
  whitelabel?: boolean;
}

export function HowItWorksSection({ title, description, whitelabel }: HowItWorksSectionProps) {
  const displayTitle = title || "How It Works";

  const steps = [
    {
      number: 1,
      title: "Find Locations",
      description: "Visit each location and look for the IYK NFC tag",
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
    },
    {
      number: 2,
      title: "Scan & Claim",
      description: "Tap your phone on the NFC tag to claim your digital reward",
      bgColor: "bg-green-100",
      textColor: "text-green-600",
    },
    {
      number: 3,
      title: "Collect All",
      description: "Complete the experience by collecting all digital assets",
      bgColor: "bg-purple-100",
      textColor: "text-purple-600",
    },
  ];

  return (
    <div className="max-w-4xl mx-auto mt-16">
      <div
        className="rounded-lg shadow-md p-8 bg-white"
        style={whitelabel ? { backgroundColor: 'var(--theme-bg, #FFFFFF)' } : undefined}
      >
        <h2
          className="text-2xl font-bold mb-6 text-center text-gray-900"
          style={whitelabel ? { color: 'var(--theme-text, #111827)' } : undefined}
        >
          {displayTitle}
        </h2>
        {description && (
          <p
            className="text-center mb-8 text-gray-500"
            style={whitelabel ? { color: 'var(--theme-text, #6B7280)', opacity: 0.8 } : undefined}
          >
            {description}
          </p>
        )}
        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div
                className={`${step.bgColor} rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4`}
              >
                <span className={`text-2xl font-bold ${step.textColor}`}>
                  {step.number}
                </span>
              </div>
              <h3
                className="font-semibold mb-2 text-gray-900"
                style={whitelabel ? { color: 'var(--theme-text, #111827)' } : undefined}
              >
                {step.title}
              </h3>
              <p
                className="text-sm text-gray-500"
                style={whitelabel ? { color: 'var(--theme-text, #6B7280)', opacity: 0.8 } : undefined}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
